<template>
  <div class="account-pages my-5 pt-sm-5">
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
               <div class="bg-soft-primary">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-primary p-4">
                           <h5 class="text-primary">Login</h5>
                           <p>Sign into SpaceMine.</p>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div>
                    <div class="avatar-md profile-user-wid mb-4">
                      <span class="avatar-title rounded-circle bg-light">
                        <img src="../../assets/images/spacemine-icon.svg" alt="" height="34">
                      </span>
                    </div>
                  </div>
                  <div class="p-2">
                     <form class="form-horizontal" action="index.html">
                        <div class="form-group">
                           <label for="email">Email</label>
                           <input v-model="email" type="email" class="form-control" id="email" placeholder="Enter email address">
                        </div>
                        <div class="form-group">
                           <label for="userpassword">Password</label>
                           <input v-model="password" type="password" class="form-control" id="userpassword" placeholder="Enter password">
                        </div>
                        <div class="custom-control custom-checkbox">
                           <input v-model="remember" type="checkbox" class="custom-control-input" id="customControlInline">
                           <label class="custom-control-label" for="customControlInline">Remember Me</label>
                        </div>
                        <div class="mt-3">
                           <button v-on:click="login" class="btn btn-primary btn-block waves-effect waves-light">Log In</button>
                        </div>
                        <div class="mt-4 text-center">
                             <router-link :to="{ name: 'recover', params: {} }" class="text-muted"><i class="mdi mdi-lock mr-1"></i> Forgot your password?</router-link>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
            <div class="mt-5 text-center">
               <div>
                  <p>Don't have an account? <router-link :to="{ name: 'register' }" class="font-weight-medium text-primary"> Register Here</router-link> </p>
                  <p>
                     Copyright &copy; SpaceMine Ltd. 2017 - {{ year }}.
                  </p>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</template>

<script>
import store from '../../store'
export default
{
  name: 'Login',
  data () {
    return {
      year: (new Date().getFullYear()),
      email: '',
      password: '',
      remember: false
    }
  },
  methods: {
    login: function (e) {
      e.preventDefault(true)
      let data = new URLSearchParams()
      data.set('email', this.email)
      data.set('password', this.password)
      fetch(store.state.url + '/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: data
      }).then(response => {
        return response.json()
      }).then(data => {
        store.commit('token', data.token)
        store.dispatch('getName')
        this.$router.push({ name: 'servers' })
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue